import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdminMatchmakingPanel.css";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { FaUsers, FaChartLine, FaComments } from "react-icons/fa";
import { Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer } from "@mui/material";

const AdminMatchmakingPanel = () => {
  const [analytics, setAnalytics] = useState({});
  const [feedback, setFeedback] = useState([]);

  useEffect(() => {
    axios.get("/api/matchmaking-insights").then((response) => {
      setAnalytics(response.data.analytics);
      setFeedback(response.data.feedback);
    });
  }, []);

  return (
    <div className="admin-panel-container">
      <h2 className="admin-title">Matchmaking & Partner Preferences Insights</h2>
      
      <div className="stats-container">
        <div className="stat-card">
          <FaUsers className="icon" />
          <h3>Total Users</h3>
          <p>{analytics.totalUsers || 0}</p>
        </div>
        <div className="stat-card">
          <FaChartLine className="icon" />
          <h3>Successful Matches</h3>
          <p>{analytics.successfulMatches || 0}</p>
        </div>
        <div className="stat-card">
          <FaComments className="icon" />
          <h3>User Feedback</h3>
          <p>{feedback.length}</p>
        </div>
      </div>

      <div className="charts-container">
        <BarChart width={400} height={300} data={analytics.engagementData || []}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="value" fill="#8884d8" />
        </BarChart>

        <LineChart width={400} height={300} data={analytics.matchTrends || []}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="value" stroke="#82ca9d" />
        </LineChart>
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Feedback</TableCell>
              <TableCell>Rating</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {feedback.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.user}</TableCell>
                <TableCell>{item.comment}</TableCell>
                <TableCell>{item.rating}/5</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default AdminMatchmakingPanel;
